module.exports = __webpack_public_path__ + "vats.png?7df2b53ad639d97f3f940ef24ed42198";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vats.png
// module id = 250
// module chunks = 0